module.exports = {
      id: "cricket-usage",
      viewBox: "0 0 21.217 19.952",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#cricket",
      toString: function () {
        return this.url;
      }
    }